import React, { FC, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

interface InputPanelProps {
  body?: string;
  text?: string;
  footer?: string;
  children?: ReactNode;
}

export const PanelWrapper: FC<InputPanelProps> = ({
  body,
  text,
  footer,
  children,
}) => (
  <Box className="flex flex-col w-full gap-2">
    {body && (
      <Typography variant="body2" className="!text-[16px] !text-text-1">
        {body}
      </Typography>
    )}
    {text && (
      <Box className="mb-4">
        <Typography variant="body2" color="text.secondary">
          {text}
        </Typography>
      </Box>
    )}
    {children}
    {footer && (
      <Typography variant="subtitle2" color="GrayText">
        {footer}
      </Typography>
    )}
  </Box>
);
